// Lightweight authentication checker
import axios from 'axios'
import { getCookie, deleteCookie } from './cookies'

// Configure API endpoint
const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT

export async function checkAuthentication() {
  // First check cookies for existing authentication
  const storedToken = getCookie('X-User-Access-Token')

  if (!storedToken) {
    return { authenticated: false, user: null }
  }

  // Configure axios with token
  axios.defaults.headers.common['X-User-Access-Token'] = storedToken

  // Validate token by fetching user data
  try {
    const response = await axios.get(`${API_ENDPOINT}/api/sales/users/current.json`)
    if (response.data) {
      return { authenticated: true, user: response.data }
    }
  } catch (error) {
    console.error('auth-check - API error:', error.response?.status, error.message)
    // Clear invalid cookies
    deleteCookie('X-User-Access-Token')
  }

  return { authenticated: false, user: null }
}

export function redirectToLogin() {
  // Redirect to our local auth page
  window.location.href = '/auth'
}
